/**
 * 【意见反馈页】
 */
import React from 'react';
import OrderSearch from './components/OrderSearch';
import OrderTable from './components/OrderTable';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import DealModal from './modal/DealModal';
import DetailModal from './modal/DetailModal';
import http from '@/assets/api/http';
import { message } from 'antd';
import OnlinePlayModal from './modal/OnlinePlayModal';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import model from '@/reducers/aftersale/suggestions/model';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';

class Main extends React.Component {

    state = {
        param: {},
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }
    searchParam = (param) => {
        this.setState({ param }, () => {
            if (Object.keys(param).length == 0) {
                this.setState({ pageSize: 10, pageNum: 1 }, () => {
                    this._searchHandle('useCache');
                })
            } else {
                this._searchHandle('useCache');
            }
           
        });
    }
    _refresh = () => {
        this._searchHandle('useCache');
    }
    _searchHandle = (useCache) => {
        const { param, pageNum, pageSize } = this.state;
        this.searchCache = {
            ...param,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getlistIdeaBack(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }
    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({
            pageSize,
            pageNum,
        }, () => {
            this._searchHandle('useCache');
        });
       
    }
    // 表格操作
    _tableAction = (record, type) => {
        switch (type) {
            case 'deal':
                this.setState({ currentOpenMode: 'deal', openModeParam: record.id });
                break;
            case 'detail':
                this.setState({ currentOpenMode: 'detail', openModeParam: { id: record.id, appType: record.appType } });
                break;
            case 'play':
                this.setState({ currentOpenMode: 'play', openModeParam: record.videoUrl, urlParam: record.videoUrl });
                break;
        }
    }
    //打开弹窗
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'deal':
                return <DealModal title='处理意见' data={{ id: this.state.openModeParam }} refresh={this._refresh} visible={true} closeMode={this._closeMode} />;
            case 'detail':
                return <DetailModal title='意见反馈详情' refresh={this._refresh} data={this.state.openModeParam} visible={true} closeMode={this._closeMode} />;
            case 'play':
                return <OnlinePlayModal visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeMode = () => {
        this.setState({ currentOpenMode: '' });
    }
    render() {
        const { listIdeaBack } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <OrderSearch searchParam={this.searchParam} />
                    <OrderTable renderData={listIdeaBack} paginationChange={this._paginationChange} tableAction={this._tableAction} />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
    getlistIdeaBack: PropTypes.func,
    listIdeaBack: PropTypes.object,
};
const mapStateToProps = (state) => ({
    listIdeaBack: state.suggestions.listIdeaBack,
    
});
export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);
